import React, { useEffect, useState } from "react";
import { NavLink } from "react-router-dom";
import Swal from "sweetalert2";
import { cargarApelaciones, firmarApelacion } from "../../utils/Datos";
import { PlaceholderTabla } from "../Otros/Placeholder";

export const ListaApeladasPendientes = ({ idProcess }) => {
  const [datos, setDatos] = useState(null);
  const [cargandoDatos, setCargandoDatos] = useState(false);

  const handleClick = (id_participant) => {
    setCargandoDatos(true);
    firmarApelacion(id_participant).then((respuesta) => {
      if (respuesta.status === true) {
        Swal.fire({
          title: "Listo",
          text: "Firma enviada",
          icon: "success",
          confirmButtonText: "Ok",
        });
      } else {
        Swal.fire({
          title: "Error",
          text: respuesta.errores ?? "Ocurrió un error",
          icon: "error",
          confirmButtonText: "Ok",
        });
      }
      setCargandoDatos(false);
    });
  };

  useEffect(() => {
    setCargandoDatos(true);
    cargarApelaciones(idProcess).then((datos) => {
      setDatos(datos.datos);
      console.log('apelaciones',datos.datos);
      setCargandoDatos(false);
    });
  }, []);

  return datos == null || cargandoDatos ? (
    <PlaceholderTabla></PlaceholderTabla>
  ) : (
    <table className="table table-rounded table-striped border gy-7 gs-7">
      <thead>
        <tr className="fw-bold fs-6 text-gray-800 border-bottom border-gray-200">
          <th>Rut</th>
          <th>Nombre</th>
          <th>Dirección</th>
          <th>Unidad</th>
          <th>Precalificar</th>
          <th>Verificar</th>
          <th>Firma</th>
        </tr>
      </thead>
      <tbody>
        {datos.length < 1 ? (
          <tr>
            <td colSpan={7}>No hay apelaciones</td>
          </tr>
        ) : (
          datos.map((d, index) => {
            return (
              <tr>
                <td>{d.rutOfficer}</td>
                <td>{d.nameOficcer}</td>
                <td>{d.nameDmunicipal}</td>
                <td>{d.nameUmunicipal}</td>
                <td>{d.namePrequalifier}</td>
                <td>
                  <NavLink
                    to={`/verProcesoFuncionario/${idProcess}/${d.id_participant}`}
                    className="btn btn-sm btn-outline btn-outline-dashed btn-outline-dark btn-active-light-dark"
                  >
                     ver
                  </NavLink>
                </td>
                <td>
                  <button
                    onClick={() => handleClick(d.id_participant)}
                    className="btn btn-sm btn-outline btn-outline-dashed btn-outline-dark btn-active-light-dark"
                  >
                     Firmar
                  </button>
                </td>
              </tr>
            );
          })
        )}
      </tbody>
    </table>
  );
};
